import "./voteContainer.scss";

import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import { getQuizzs } from "../../../../redux/action/quizz/QuizzAction";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumbs from "@components/breadcrumbs/index1";
import { Row, Col, Card, CardBody } from "reactstrap";
import { CustomPagination } from "@store/action/GlobalAction";
import { useForm } from "react-hook-form";
import { Input, Label } from "reactstrap";
const VoteContainer = () => {
  const { t } = useTranslation();
  const quizzes = useSelector((store) => store.QuizzReducer.quizzes);
  const count = useSelector((store) => store.QuizzReducer.quiz_total);

  const [perPage, setPerPage] = useState(5);
  const [page, setPage] = useState(1);
  const renderVotes = () => <></>;
  // ** States

  const dispatch = useDispatch();

  useEffect(() => {
    getQuizzs(perPage, page, dispatch);
  }, [perPage, page]);

  // ** Hooks

  const FrontofficeThemeReducer = useSelector(
    (state) => state.FrontofficeThemeReducer
  );
  const tuneIn_theme =
    FrontofficeThemeReducer?.design_by_radio?.backgroundcolors.name;
  const themeStore = FrontofficeThemeReducer;
  const tempalte = themeStore?.design_by_radio?.templates.id;
  const localStorageTheme = localStorage.getItem("tuneIn_theme");
  const handelPagination = (p) => {
    setPage(p.selected + 1);
  };
  return (
    <>
   
      {tempalte === 2 ? (
        <BreadCrumbs breadCrumbTitle={t("Vote")} />
      ) : (
        <section className="single-banner" style={{ width: "100%" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="single-content">
                  <h2>{t("Vote")}</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">{t("Home")}</Link>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <div
        className={`voteWrapper `}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",

        }}
      >
        <span
          style={{
            display: "flex",
            flexDirection: "row",
            width: "80%",
            alignItems: "center",
            justifyContent: "space-evenly",
     
          }}
        >
          <div className=" align-items-center ">
            {/* <Button color="primary" onClick={toggleSidebar}>
                <span className="align-middle ">{t("Add Vote")}</span>
              </Button> */}
            <Label>per page </Label>{" "}
            <Input
              style={{ width: "80px" }}
              onChange={(perpage) => {
                setPerPage(perpage.target.value);
              }}
              type="select"
            >
              <option value={5}>5</option>
              <option value={7}>7</option>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={35}>35</option>
              <option value={1940}>all</option>
            </Input>
          </div>
        </span>

        <div className="votesBodyContainer">
          <div className="votesContainer">
            <Fragment>
              <Row>
                {quizzes?.map((item, index) => {
                  return item.is_active ? (
                    <Col
                      key={index + "Vote"}
                      style={{ minWidth: "360px" }}
                      xl={4}
                      md={6}
                    >
                      <Card>
                        <CardBody
                          className={`${
                            (tuneIn_theme || localStorageTheme) === "white"
                              ? "whitetheme"
                              : ""
                          } `}
                        >
                          <div className="d-flex justify-content-between">
                            <span>{`${t("total answers")} ${5}`}</span>
                          </div>
                          <div className="d-flex justify-content-between align-items-end mt-1 pt-1">
                            <div className="role-heading">
                              <h4>{item.title}</h4>
                            </div>
                            <Link
                              to=""
                              className="text-body"
                              onClick={(e) => e.preventDefault()}
                            ></Link>
                          </div>
                        </CardBody>
                        <Link to={`/vote/question/${item.id}`}>
                          <div
                            className="voteButtonContainer"
                            onClick={(e) => {}}
                          >
                            <span className="fw-bolder">Vote</span>
                            <img src="https://res.cloudinary.com/jobify/image/upload/v1669109599/1031962_kmvrw9.png" />
                          </div>
                        </Link>
                      </Card>
                    </Col>
                  ) : (
                    <></>
                  );
                })}
              </Row>
            </Fragment>
          </div>
        </div>
        {CustomPagination(count, perPage, handelPagination)}
      </div>
    </>
  );
};

export default VoteContainer;
